<template lang='pug'>
  div
    div.lmm-content-body-padded
      // 제목 부분
      b-container.d-flex.justify-content-between(fluid)
        div.d-flex
          div.application-header(slot="header")
            span {{$t('application')}}/{{$t('version')}} ({{this.tableData.pagination.total}})
      
      // 검색 및 애플리케이션 추가 부분
      b-container(fluid)
        b-row.search-form.no-rule(v-if="!AppState.isMobile")
          b-col.d-flex.align-items-center
            span(ref="titleSpan")
      
      // 테이블
      b-container.devices(fluid)
        div.row
          b-card.table-card(v-if="!AppState.isMobile")
            b-table(
              ref="applicationTableBody",
              :fields="tableData.fields",
              :items="fetchApplicationList",
              :current-page="tableData.pagination.current",
              :per-page="tableData.pagination.limit",
              :empty-text="$t('no-content')",
              :class="tableClass",
              tbody-class="lmm-table-body",
              sort-by="app_version",
              :sort-desc="false",
              show-empty
              responsive
            )
              template(#cell(action)='row')
                div.nowrap
                  b-button-group
                    b-dropdown(dropleft size="sm", variant="white" :text="$t('columns.actions')" @show="openDropDown" @hidden="closeDropDown")
                      b-dropdown-item(@click="openSettingDialog(row.item.pk)")
                        span {{$t('applications.setting')}}
                      b-dropdown-item(@click="openEditDialog(row.item.pk)")
                        span {{$t('applications.edit')}}
                      b-dropdown-item(@click="deleteApplication(row.item.pk)")
                        span {{$t('applications.delete')}}
      
      div.pagination-wrap
        div
          b-form-select(
            size="sm",
            v-model="tableData.pagination.limit",
            :options="tableData.pagination.perOptions")
        b-pagination(
          size="sm",
          v-model="tableData.pagination.current",
          :total-rows="tableData.pagination.total",
          :per-page="tableData.pagination.limit",
          class="my-0 float-right"
        )
      
    DialogSetting(:show='isSettingModalVisible' :pk='localApplicationPk' @close='closeModal')
    DialogApplicationEdit(:show='isEditModalVisible' :pk='localApplicationPk' @close='closeModal')
</template>

<script>
import { ApplicationsAPI } from '@/api'
import DialogSetting from '@/components/application/components/DialogSetting.vue'
import DialogApplicationEdit from '@/components/application/components/DialogApplicationEdit.vue'

export default {
  name: 'ApplicationDetail',
  components: {DialogApplicationEdit, DialogSetting},
  props: {
    applicationPk: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      tableClass: '',
      isSettingModalVisible: false,
      isAddModalVisible: false,
      isEditModalVisible: false,
      localApplicationPk: Number(this.applicationPk),
      tableData: {
        fields: [
          {key: 'app_name', label: this.$t('app_name'), sortable: true, thStyle: {minWidth: '120px'}},
          {key: 'app_version', label: this.$t('app_version'), sortable: true, thStyle: {minWidth: '120px'}},
          {key: 'url', label: this.$t('url'), sortable: true, thStyle: {minWidth: '150px'}},
          {key: 'action', label: this.$t('action'), sortable: false, thStyle: {minWidth: '50px'}},
        ],
        pagination: {
          by: 'create_time',
          limit: 24,
          offset: 0,
          order: 'desc',
          
          search_key: '',
          search_value: '',
          search_mode: 'pagination',
          
          total: 1,
          current: 1,
          perOptions: [
            {value: 12, text: '12'},
            {value: 24, text: '24'},
            {value: 36, text: '36'},
          ],
        },
      },
    }
  },
  methods: {
    fetchApplicationList(ctx) {
      if (ctx.sortBy === '') {
        return
      }
      
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? 'desc' : 'asc'
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit
      
      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
      }
      
      return ApplicationsAPI.get(`${this.localApplicationPk}`, {params})
          .then(res => {
            const {objects, meta, status} = res.data
            
            if (status !== 200) {
              this.$awn.warning(this.$t('data_get_fail'))
              return []
            }
            
            this.tableData.list = objects
            this.tableData.pagination.total = meta.total_count
            
            if (this.tableData.list.length > 0) {
              this.$refs.titleSpan.innerText = `${this.tableData.list[0].file_name}`
            } else {
              this.$refs.titleSpan.innerText = ``
            }
            
            return this.tableData.list
          })
    },
    openDropDown() {
      this.tableClass = 'show-dropdown'
    },
    closeDropDown() {
      this.tableClass = ''
    },
    closeModal() {
      this.isSettingModalVisible = false
      this.isAddModalVisible = false
      this.isEditModalVisible = false
      this.localApplicationPk = Number(this.applicationPk)
      this.$refs.applicationTableBody.refresh()
    },
    openSettingDialog(pk) {
      this.localApplicationPk = pk
      this.isSettingModalVisible = true
    },
    openEditDialog(pk) {
      this.localApplicationPk = pk
      this.isEditModalVisible = true
    },
    deleteApplication(pk) {
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_checked_application_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        ApplicationsAPI.delete(`${pk}`)
            .then(res => {
              this.$awn.success(this.$t("app_info_delete"))
              this.$refs.applicationTableBody.refresh()
            })
        
        if (pk === this.localApplicationPk) {
          const currentPath = this.$route.path;
          const newPath = currentPath.replace(/\/all\/\d+$/, '/all');
          
          this.$router.push(newPath);
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.pagination-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fafafa;
  border: 1px solid #d2d2d2;
  border-top: 0;
  padding: 10px 20px;
  width: 100%;
}

.application-header {
  padding-bottom: .5rem;
  color: #000000;
  font-size: 1.2rem;
  font-weight: 500;
}

.right-btns {
  button {
    height: 30px !important;
  }
}

.nowrap {
  white-space: nowrap;
}

::v-deep .dropdown-toggle::before {
  margin-right: 7px;
}
</style>